module.exports = __webpack_public_path__ + "img/savanah_content_img_04.5bc8a7f6.jpg";